// СГЕНЕРИРОВАНО генератором миссий (developer_artifacts/scripts/missionGen).
// Правится не руками, а перегенерацией: npx tsx developer_artifacts/scripts/missionGen/generate_humans_3.cjs
/* eslint-disable */
const mission = {
  "id": "humans_3",
  "campaignFactionId": "humans",
  "order": 3,
  "title": "Верцелльское поле",
  "shortTitle": "Миссия III",
  "description": "Выстои против орды — и узнай, кто живёт под всеми полями",
  "finalRound": 10,
  "reward": {
    "type": "chest",
    "chestId": "chest_skins_gold"
  },
  "rewardIfFactionOwned": null,
  "playerColor": "blue",
  "players": [
    {
      "name": "Луций",
      "color": "blue",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": false,
      "bonus": "none"
    },
    {
      "name": "Гхарзуг",
      "color": "red",
      "factionId": "orcs",
      "selectedSkin": "orcs_default",
      "isBot": true,
      "bonus": "none"
    },
    {
      "name": "Регин",
      "color": "yellow",
      "factionId": "dwarves",
      "selectedSkin": "dwarves_default",
      "isBot": true,
      "bonus": "none"
    }
  ],
  "field": {
    "hexes": {
      "-8,-4": "sea",
      "-7,-4": "sea",
      "-6,-4": "sea",
      "-5,-5": "sea",
      "-4,-5": "sea",
      "-3,-5": "sea",
      "-2,-5": "sea",
      "-1,-5": "sea",
      "0,-6": "sea",
      "1,-6": "sea",
      "2,-6": "sea",
      "3,-6": "sea",
      "4,-6": "sea",
      "5,-6": "sea",
      "6,-6": "sea",
      "6,-5": "sea",
      "7,-5": "sea",
      "8,-5": "sea",
      "9,-5": "sea",
      "-8,-3": "sea",
      "-9,-2": "sea",
      "-9,-1": "sea",
      "-9,0": "sea",
      "-10,1": "sea",
      "-10,2": "sea",
      "-10,3": "sea",
      "-9,3": "sea",
      "-9,4": "sea",
      "-9,5": "sea",
      "-9,6": "sea",
      "-8,6": "sea",
      "-8,7": "sea",
      "-8,8": "sea",
      "-5,0": "flag_blue",
      "-6,1": "quarter",
      "-4,-1": "quarter",
      "-5,1": "quarter",
      "-4,0": "quarter",
      "-6,0": "farm",
      "-5,-1": "farm",
      "-6,2": "farm",
      "-4,1": "barracks",
      "-5,2": "barracks",
      "-1,0": "ruins",
      "0,-2": "ruins",
      "-2,-2": "ruins",
      "-3,0": "road",
      "-2,0": "road",
      "0,0": "road",
      "1,0": "road",
      "2,0": "road",
      "3,0": "road",
      "4,0": "road",
      "-1,-1": "road",
      "-2,-1": "road",
      "-3,-1": "road",
      "2,2": "road",
      "3,1": "road",
      "7,0": "flag_red",
      "6,1": "quarter",
      "8,-1": "quarter",
      "7,-1": "quarter",
      "6,0": "quarter",
      "7,1": "farm",
      "8,0": "farm",
      "6,-1": "farm",
      "8,-2": "farm",
      "5,0": "farm",
      "5,1": "barracks",
      "9,-1": "barracks",
      "-3,5": "mountain",
      "-3,6": "mountain",
      "-2,4": "mountain",
      "-2,5": "mountain",
      "-2,6": "mountain",
      "-1,4": "mountain",
      "-1,5": "mountain",
      "2,4": "mountain",
      "2,5": "mountain",
      "3,3": "mountain",
      "3,4": "mountain",
      "3,5": "mountain",
      "4,3": "mountain",
      "4,4": "mountain",
      "0,5": "ruins",
      "1,5": "ruins",
      "1,8": "flag_yellow",
      "0,8": "quarter",
      "2,7": "quarter",
      "1,7": "quarter",
      "0,9": "farm",
      "2,8": "farm",
      "1,9": "farm",
      "0,7": "barracks",
      "2,6": "farm",
      "0,6": "road",
      "1,6": "road",
      "1,4": "road",
      "1,3": "road",
      "-14,0": "sea",
      "-14,3": "sea",
      "-14,6": "sea",
      "-14,9": "sea",
      "-14,12": "sea",
      "-13,-1": "sea",
      "-12,14": "sea",
      "-10,-4": "sea",
      "-9,14": "sea",
      "-7,-7": "sea",
      "-6,14": "sea",
      "-4,-10": "sea",
      "-3,14": "sea",
      "-1,-13": "sea",
      "0,14": "sea",
      "2,-14": "sea",
      "3,11": "sea",
      "5,-14": "sea",
      "6,8": "sea",
      "8,-14": "sea",
      "9,5": "sea",
      "11,-14": "sea",
      "12,2": "sea",
      "14,-14": "sea",
      "14,-11": "sea",
      "14,-8": "sea",
      "14,-5": "sea",
      "14,-2": "sea",
      "-16,0": "sea",
      "-16,1": "sea",
      "-16,2": "sea",
      "-16,3": "sea",
      "-16,4": "sea",
      "-16,5": "sea",
      "-16,6": "sea",
      "-16,7": "sea",
      "-16,8": "sea",
      "-16,9": "sea",
      "-16,10": "sea",
      "-16,11": "sea",
      "-16,12": "sea",
      "-16,13": "sea",
      "-16,14": "sea",
      "-16,15": "sea",
      "-16,16": "sea",
      "-15,-1": "sea",
      "-15,16": "sea",
      "-14,-2": "sea",
      "-14,16": "sea",
      "-13,-3": "sea",
      "-13,16": "sea",
      "-12,-4": "sea",
      "-12,16": "sea",
      "-11,-5": "sea",
      "-11,16": "sea",
      "-10,-6": "sea",
      "-10,16": "sea",
      "-9,-7": "sea",
      "-9,16": "sea",
      "-8,-8": "sea",
      "-8,16": "sea",
      "-7,-9": "sea",
      "-7,16": "sea",
      "-6,-10": "sea",
      "-6,16": "sea",
      "-5,-11": "sea",
      "-5,16": "sea",
      "-4,-12": "sea",
      "-4,16": "sea",
      "-3,-13": "sea",
      "-3,16": "sea",
      "-2,-14": "sea",
      "-2,16": "sea",
      "-1,-15": "sea",
      "-1,16": "sea",
      "0,-16": "sea",
      "0,16": "sea",
      "1,-16": "sea",
      "1,15": "sea",
      "2,-16": "sea",
      "2,14": "sea",
      "3,-16": "sea",
      "3,13": "sea",
      "4,-16": "sea",
      "4,12": "sea",
      "5,-16": "sea",
      "5,11": "sea",
      "6,-16": "sea",
      "6,10": "sea",
      "7,-16": "sea",
      "7,9": "sea",
      "8,-16": "sea",
      "8,8": "sea",
      "9,-16": "sea",
      "9,7": "sea",
      "10,-16": "sea",
      "10,6": "sea",
      "11,-16": "sea",
      "11,5": "sea",
      "12,-16": "sea",
      "12,4": "sea",
      "13,-16": "sea",
      "13,3": "sea",
      "14,-16": "sea",
      "14,2": "sea",
      "15,-16": "sea",
      "15,1": "sea",
      "16,-16": "sea",
      "16,-15": "sea",
      "16,-14": "sea",
      "16,-13": "sea",
      "16,-12": "sea",
      "16,-11": "sea",
      "16,-10": "sea",
      "16,-9": "sea",
      "16,-8": "sea",
      "16,-7": "sea",
      "16,-6": "sea",
      "16,-5": "sea",
      "16,-4": "sea",
      "16,-3": "sea",
      "16,-2": "sea",
      "16,-1": "sea",
      "16,0": "sea"
    },
    "units": [
      {
        "id": "u_blue_0_-4_0",
        "hexKey": "-4,0",
        "ownerId": "player_id_blue",
        "type": "unit_d10",
        "size": 6,
        "maxSize": 10
      },
      {
        "id": "u_blue_1_-5_1",
        "hexKey": "-5,1",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 4,
        "maxSize": 6
      },
      {
        "id": "u_blue_2_-4_-1",
        "hexKey": "-4,-1",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 4,
        "maxSize": 6
      },
      {
        "id": "u_red_3_6_0",
        "hexKey": "6,0",
        "ownerId": "player_id_red",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_red_4_7_-1",
        "hexKey": "7,-1",
        "ownerId": "player_id_red",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_red_5_1_0",
        "hexKey": "1,0",
        "ownerId": "player_id_red",
        "type": "unit_d10",
        "size": 9,
        "maxSize": 10
      },
      {
        "id": "u_red_6_1_-1",
        "hexKey": "1,-1",
        "ownerId": "player_id_red",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_red_7_2_1",
        "hexKey": "2,1",
        "ownerId": "player_id_red",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "orc_gharzug",
        "hexKey": "2,-2",
        "ownerId": "player_id_red",
        "type": "unit_d12",
        "size": 12,
        "maxSize": 12
      }
    ],
    "specialBuildings": {
      "-4,0": "fortress"
    },
    "gridConfig": {
      "radius": 20,
      "hexSize": 60,
      "orientation": "flat"
    }
  },
  "policyMarket": [
    {
      "id": "fanaticism",
      "name": "Фанатизм",
      "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
      "implemented": true,
      "color": "#A9A9A9"
    },
    {
      "id": "agrarianism",
      "name": "Аграризм",
      "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
      "implemented": true,
      "color": "#D68A5A"
    },
    {
      "id": "isolationism",
      "name": "Изоляционизм",
      "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
      "implemented": true,
      "color": "#b09292"
    },
    {
      "id": "despotism",
      "name": "Деспотизм",
      "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
      "implemented": true,
      "color": "#98172d"
    },
    {
      "id": "militarism",
      "name": "Милитаризм",
      "description": "Увеличенный урон в ближнем бою",
      "implemented": true,
      "color": "#98172d"
    },
    {
      "id": "industrialism",
      "name": "Индустриализм",
      "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
      "implemented": true,
      "color": "#865333"
    }
  ],
  "script": [
    {
      "id": "e_0_replica",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Не ищи друзей, Луций, — у Рима их не бывает. У Рима бывают должники и данники, и это надёжнее дружбы: долг можно взыскать, дружбу — только потерять. Если кто-то помог тебе бескорыстно — ты просто ещё не видел счёта. — М. Аврелий Скавр, сыну»",
        "characterName": "Из писем отца",
        "side": "left",
        "characterImage": "/img/campaigns/humans/letters_marc.png"
      }
    },
    {
      "id": "e_1_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h3_hold_line",
        "type": "survive_rounds",
        "params": {
          "rounds": 6
        },
        "text": "Выстои до перелома",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_2_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h3_keep_vercellae",
        "type": "keep_city",
        "params": {
          "centralHexKey": "-5,0"
        },
        "text": "Удержи Верцеллы",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_3_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h3_army_size",
        "type": "units_total_size",
        "params": {
          "amount": 24
        },
        "text": "Собери войско отчаяния",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_4_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h3_destroy_horde",
        "type": "destroy_all_enemy_units",
        "params": {
          "color": "red"
        },
        "text": "Истреби орду",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_5_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h3_tan_word",
        "type": "survive_rounds",
        "params": {
          "rounds": 10
        },
        "text": "Дождись слова тана",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_6_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h3_lose_vercellae",
        "type": "lose_city",
        "params": {
          "centralHexKey": "-5,0"
        },
        "text": "Не потеряй Верцеллы",
        "isMain": false,
        "isFailure": true
      }
    },
    {
      "id": "entry_7_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_red",
          "hexKey": "7,0"
        }
      }
    },
    {
      "id": "entry_8_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_red",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_9_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_yellow",
          "hexKey": "1,8"
        }
      }
    },
    {
      "id": "entry_10_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_yellow",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_11_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true,
            "color": "#865333"
          },
          "round": 0,
          "currentPlayerId": "player_id_yellow",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_12_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат. У южной стены — кимвры. Сорок мечей, из пленных. Стоят. Говорят — в строй хотят. Прикажешь разогнать?",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_atilius_grim.png"
      }
    },
    {
      "id": "e_13_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Кто их привёл?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_lucius_stern.png"
      }
    },
    {
      "id": "e_14_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Никто, господин. Они сами. Ты не решил тогда, у рудника, что с нами делать. Вот они и пришли — помочь тебе с ответом.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m3_ilva_calm.png"
      }
    },
    {
      "id": "e_15_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Слыхал, легат? Твоё нерешённое решение стоит у южной стены и просит железа. Дай им железо. Против ЭТОГО — все люди одной масти.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_barba_grin.png"
      }
    },
    {
      "id": "e_16_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Выдать оружие. Поставить… …не отдельно. Вперемешку с нашими. Пусть стена будет одна.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_lucius_resolve.png"
      }
    },
    {
      "id": "entry_17_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,0",
          "unitId": "u_red_5_1_0",
          "unitHexKey": "1,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_18_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,1",
          "unitId": "u_red_4_7_-1",
          "unitHexKey": "7,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_19_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-2",
          "unitId": "u_red_3_6_0",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_20_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-1",
          "unitId": "u_red_7_2_1",
          "unitHexKey": "2,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_21_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,0",
          "unitId": "u_red_6_1_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_22_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_23_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_24_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 1,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_25_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_26_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_27_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true,
            "color": "#865333"
          },
          "round": 1,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_28_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_29_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_30_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_5_1_0",
          "unitType": "unit_d10",
          "newHexKey": "-1,0"
        }
      }
    },
    {
      "id": "entry_31_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_5_1_0",
          "fromHexKey": "1,0",
          "toHexKey": "-1,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_32_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_6_1_-1",
          "unitType": "unit_d6",
          "newHexKey": "0,0"
        }
      }
    },
    {
      "id": "entry_33_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_6_1_-1",
          "fromHexKey": "1,-1",
          "toHexKey": "0,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_34_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_7_2_1",
          "unitType": "unit_d6",
          "newHexKey": "2,0"
        }
      }
    },
    {
      "id": "entry_35_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_7_2_1",
          "fromHexKey": "2,1",
          "toHexKey": "2,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_36_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_gharzug",
          "unitType": "unit_d12",
          "newHexKey": "1,-1"
        }
      }
    },
    {
      "id": "entry_37_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_gharzug",
          "fromHexKey": "2,-2",
          "toHexKey": "1,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_38_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_3_6_0",
          "unitType": "unit_d10",
          "newHexKey": "4,0"
        }
      }
    },
    {
      "id": "entry_39_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_3_6_0",
          "fromHexKey": "6,0",
          "toHexKey": "4,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_40_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "unitType": "unit_d10",
          "newHexKey": "5,-1"
        }
      }
    },
    {
      "id": "entry_41_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "fromHexKey": "7,-1",
          "toHexKey": "5,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_42_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_43_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_44_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_45_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_46_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 1,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_47_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 1,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_48_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,0",
          "unitId": "orc_gharzug",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_49_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,1",
          "unitId": "u_red_4_7_-1",
          "unitHexKey": "5,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_50_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-2",
          "unitId": "u_red_3_6_0",
          "unitHexKey": "4,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_51_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-1",
          "unitId": "u_red_7_2_1",
          "unitHexKey": "2,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_52_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,0",
          "unitId": "u_red_6_1_-1",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_53_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_54_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_55_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 2,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_56_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_57_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_58_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true,
            "color": "#865333"
          },
          "round": 2,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_59_RECRUIT_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "RECRUIT_UNIT",
        "payload": {
          "hexKey": "5,1",
          "unitType": "unit_d6",
          "factionId": "orcs",
          "price": 2,
          "unitId": "rec_red_2_5_1"
        }
      }
    },
    {
      "id": "entry_60_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "actionType": "UNIT_RECRUITMENT",
          "quarterHexKey": "5,1",
          "price": 2,
          "sizeAdded": 0
        }
      }
    },
    {
      "id": "entry_61_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "5,1",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_62_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "5,1",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_63_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "5,1",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_64_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_65_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_66_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_5_1_0",
          "unitType": "unit_d10",
          "newHexKey": "-2,-1"
        }
      }
    },
    {
      "id": "entry_67_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_5_1_0",
          "fromHexKey": "-1,0",
          "toHexKey": "-2,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_68_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_6_1_-1",
          "unitType": "unit_d6",
          "newHexKey": "-1,-1"
        }
      }
    },
    {
      "id": "entry_69_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_6_1_-1",
          "fromHexKey": "0,0",
          "toHexKey": "-1,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_70_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_7_2_1",
          "unitType": "unit_d6",
          "newHexKey": "0,0"
        }
      }
    },
    {
      "id": "entry_71_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_7_2_1",
          "fromHexKey": "2,0",
          "toHexKey": "0,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_72_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_gharzug",
          "unitType": "unit_d12",
          "newHexKey": "1,0"
        }
      }
    },
    {
      "id": "entry_73_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_gharzug",
          "fromHexKey": "1,-1",
          "toHexKey": "1,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_74_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_3_6_0",
          "unitType": "unit_d10",
          "newHexKey": "2,0"
        }
      }
    },
    {
      "id": "entry_75_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_3_6_0",
          "fromHexKey": "4,0",
          "toHexKey": "2,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_76_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "unitType": "unit_d10",
          "newHexKey": "3,0"
        }
      }
    },
    {
      "id": "entry_77_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "fromHexKey": "5,-1",
          "toHexKey": "3,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_78_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_79_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_80_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_81_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_82_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 2,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_83_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 2,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_84_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,0",
          "unitId": "orc_gharzug",
          "unitHexKey": "1,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_85_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,1",
          "unitId": "u_red_4_7_-1",
          "unitHexKey": "3,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_86_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-2",
          "unitId": "u_red_3_6_0",
          "unitHexKey": "2,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_87_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-1",
          "unitId": "u_red_7_2_1",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_88_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,0",
          "unitId": "rec_red_2_5_1",
          "unitHexKey": "5,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_89_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_90_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_91_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 3,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_92_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_93_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_94_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 3,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_95_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_96_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_97_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_5_1_0",
          "unitType": "unit_d10",
          "newHexKey": "-3,-1"
        }
      }
    },
    {
      "id": "entry_98_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_5_1_0",
          "fromHexKey": "-2,-1",
          "toHexKey": "-3,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_99_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_6_1_-1",
          "unitType": "unit_d6",
          "newHexKey": "-2,-1"
        }
      }
    },
    {
      "id": "entry_100_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_6_1_-1",
          "fromHexKey": "-1,-1",
          "toHexKey": "-2,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_101_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "orc_gharzug",
          "unitType": "unit_d12",
          "newHexKey": "-3,0"
        }
      }
    },
    {
      "id": "entry_102_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "orc_gharzug",
          "fromHexKey": "1,0",
          "toHexKey": "-3,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_103_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_7_2_1",
          "unitType": "unit_d6",
          "newHexKey": "-2,0"
        }
      }
    },
    {
      "id": "entry_104_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_7_2_1",
          "fromHexKey": "0,0",
          "toHexKey": "-2,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_105_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_3_6_0",
          "unitType": "unit_d10",
          "newHexKey": "0,0"
        }
      }
    },
    {
      "id": "entry_106_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_3_6_0",
          "fromHexKey": "2,0",
          "toHexKey": "0,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_107_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "unitType": "unit_d10",
          "newHexKey": "1,0"
        }
      }
    },
    {
      "id": "entry_108_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "fromHexKey": "3,0",
          "toHexKey": "1,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_109_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "unitType": "unit_d6",
          "newHexKey": "4,0"
        }
      }
    },
    {
      "id": "entry_110_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "fromHexKey": "5,1",
          "toHexKey": "4,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_111_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_112_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "combat",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_116_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_117_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_118_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 3,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_119_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 3,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_120_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,0",
          "unitId": "u_red_4_7_-1",
          "unitHexKey": "1,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_121_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,1",
          "unitId": "u_red_3_6_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_122_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-2",
          "unitId": "rec_red_2_5_1",
          "unitHexKey": "4,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_123_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-1",
          "unitId": "u_red_4_7_-1",
          "unitHexKey": "1,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_124_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,0",
          "unitId": "u_red_3_6_0",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_125_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_126_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_127_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 4,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_128_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_129_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_130_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true,
            "color": "#DEA806"
          },
          "round": 4,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_131_RECRUIT_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "RECRUIT_UNIT",
        "payload": {
          "hexKey": "9,-1",
          "unitType": "unit_d4",
          "factionId": "orcs",
          "price": 8,
          "unitId": "rec_red_4_9_-1"
        }
      }
    },
    {
      "id": "entry_132_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_red_4_9_-1",
          "actionType": "UNIT_RECRUITMENT",
          "quarterHexKey": "9,-1",
          "price": 8,
          "sizeAdded": 0
        }
      }
    },
    {
      "id": "entry_133_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_red_4_9_-1",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "9,-1",
          "price": 4,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_134_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_135_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_136_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_6_1_-1",
          "unitType": "unit_d6",
          "newHexKey": "-3,-2"
        }
      }
    },
    {
      "id": "entry_137_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_6_1_-1",
          "fromHexKey": "-2,-1",
          "toHexKey": "-3,-2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_138_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_7_2_1",
          "unitType": "unit_d6",
          "newHexKey": "-4,1"
        }
      }
    },
    {
      "id": "entry_139_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_7_2_1",
          "fromHexKey": "-2,0",
          "toHexKey": "-4,1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_140_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_3_6_0",
          "unitType": "unit_d10",
          "newHexKey": "-2,0"
        }
      }
    },
    {
      "id": "entry_141_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_3_6_0",
          "fromHexKey": "0,0",
          "toHexKey": "-2,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_142_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "unitType": "unit_d10",
          "newHexKey": "1,-1"
        }
      }
    },
    {
      "id": "entry_143_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "fromHexKey": "1,0",
          "toHexKey": "1,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_144_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "unitType": "unit_d6",
          "newHexKey": "2,0"
        }
      }
    },
    {
      "id": "entry_145_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "fromHexKey": "4,0",
          "toHexKey": "2,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_146_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_147_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "combat",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_151_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_152_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_153_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 4,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_154_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true,
            "color": "#865333"
          },
          "round": 4,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_155_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,0",
          "unitId": "rec_red_4_9_-1",
          "unitHexKey": "9,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_156_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,1",
          "unitId": "u_red_4_7_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_157_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-2",
          "unitId": "rec_red_2_5_1",
          "unitHexKey": "2,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_158_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-1",
          "unitId": "u_red_4_7_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_159_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,0",
          "unitId": "rec_red_2_5_1",
          "unitHexKey": "2,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_160_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_161_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_162_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 5,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_163_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_164_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_165_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 5,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_166_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_167_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_168_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_3_6_0",
          "unitType": "unit_d10",
          "newHexKey": "-3,-1"
        }
      }
    },
    {
      "id": "entry_169_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_3_6_0",
          "fromHexKey": "-2,0",
          "toHexKey": "-3,-1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_170_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "unitType": "unit_d6",
          "newHexKey": "0,0"
        }
      }
    },
    {
      "id": "entry_171_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "fromHexKey": "2,0",
          "toHexKey": "0,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "e_172_replica",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "kind": "replica",
      "replica": {
        "text": "НЕ ВЫХОДИТЬ ЗА КОЛЬЯ! Стоять! Им в поле каждый наш — по горло в лапах! Стоим — живём!",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_barba_war.png"
      }
    },
    {
      "id": "e_173_replica",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат, левый фас проседает! Атилий там один с полуцентурией — он… легат, он НЕ ЗОВЁТ ПОМОЩЬ!",
        "characterName": "Дозорный",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_dozorny_battle.png"
      }
    },
    {
      "id": "e_174_replica",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "kind": "replica",
      "replica": {
        "text": "Конечно, не зовёт. Он туда не за помощью пошёл… Резерв — на левый фас! БЕГОМ!",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_lucius_command.png"
      }
    },
    {
      "id": "e_175_replica",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "kind": "replica",
      "replica": {
        "text": "Видал? Учись, мальчик: человек, которому ты должен, — самый дорогой солдат на свете. Он либо взыщет с тебя, либо взыщет С СЕБЯ. Второго — не допускай.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_barba_war.png"
      }
    },
    {
      "id": "entry_176_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_177_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "combat",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_181_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_182_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_183_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 5,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_184_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 5,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "e_185_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат!.. Земля. Земля дрожит. Под ногами. Это их барабаны?",
        "characterName": "Дозорный",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_dozorny_battle.png"
      }
    },
    {
      "id": "e_186_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Нет… Барабаны — сверху. Это — СНИЗУ. Тридцать лет я хоронил друзей в эту землю. И никогда не спрашивал, не тесно ли там.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_barba_grim.png"
      }
    },
    {
      "id": "e_187_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "ТЕСНО, старик! Ты бы знал, КАК тесно! Вахта! Счёт открыт! Бей тех, кто не платит!",
        "characterName": "Регин",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m3_regin_march.png"
      }
    },
    {
      "id": "e_188_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Кто… Во имя всех богов — КТО ВЫ?!",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_lucius_shock.png"
      }
    },
    {
      "id": "e_189_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Опоздавшие, человек! Мы — опоздавшие! Разговоры — после! У вас, молодых, вечно всё наоборот: сперва болтаете, потом дерётесь! КЛИНЬЯ!",
        "characterName": "Регин",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m3_regin_march.png"
      }
    },
    {
      "id": "e_190_spawn",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "spawn",
      "player": null,
      "units": [
        {
          "id": "dwarf_watch_1",
          "hexKey": "2,3",
          "ownerId": "player_id_yellow",
          "type": "unit_d8",
          "size": 8
        },
        {
          "id": "dwarf_watch_2",
          "hexKey": "1,4",
          "ownerId": "player_id_yellow",
          "type": "unit_d8",
          "size": 8
        },
        {
          "id": "dwarf_watch_3",
          "hexKey": "0,4",
          "ownerId": "player_id_yellow",
          "type": "unit_d8",
          "size": 8
        }
      ]
    },
    {
      "id": "entry_191_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,0",
          "unitId": "rec_red_4_9_-1",
          "unitHexKey": "9,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_192_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,1",
          "unitId": "u_red_4_7_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_193_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-2",
          "unitId": "rec_red_2_5_1",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_194_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-1",
          "unitId": "u_red_4_7_-1",
          "unitHexKey": "1,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_195_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,0",
          "unitId": "rec_red_2_5_1",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_196_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_197_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,8",
          "unitId": "dwarf_watch_2",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_198_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,9",
          "unitId": "dwarf_watch_3",
          "unitHexKey": "0,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_199_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "0,9",
          "unitId": "dwarf_watch_1",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_200_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,6",
          "unitId": "dwarf_watch_2",
          "unitHexKey": "1,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_201_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_202_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 6,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_203_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_204_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_205_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 6,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_206_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_207_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_208_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "unitType": "unit_d6",
          "newHexKey": "-2,0"
        }
      }
    },
    {
      "id": "entry_209_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "fromHexKey": "0,0",
          "toHexKey": "-2,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_210_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_211_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_212_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_213_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_214_MOVE_UNIT",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "dwarf_watch_1",
          "unitType": "unit_d8",
          "newHexKey": "4,0"
        }
      }
    },
    {
      "id": "entry_215_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "dwarf_watch_1",
          "fromHexKey": "2,3",
          "toHexKey": "4,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_216_MOVE_UNIT",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "dwarf_watch_2",
          "unitType": "unit_d8",
          "newHexKey": "3,1"
        }
      }
    },
    {
      "id": "entry_217_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "dwarf_watch_2",
          "fromHexKey": "1,4",
          "toHexKey": "3,1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_218_MOVE_UNIT",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "dwarf_watch_3",
          "unitType": "unit_d8",
          "newHexKey": "2,2"
        }
      }
    },
    {
      "id": "entry_219_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "dwarf_watch_3",
          "fromHexKey": "0,4",
          "toHexKey": "2,2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_220_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_221_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_222_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 6,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_223_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 6,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_224_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,0",
          "unitId": "rec_red_4_9_-1",
          "unitHexKey": "9,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_225_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,1",
          "unitId": "rec_red_4_9_-1",
          "unitHexKey": "9,-1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_226_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_227_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,8",
          "unitId": "dwarf_watch_3",
          "unitHexKey": "2,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_228_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,9",
          "unitId": "dwarf_watch_3",
          "unitHexKey": "2,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_229_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_230_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 7,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_231_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_232_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_233_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true,
            "color": "#D68A5A"
          },
          "round": 7,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_234_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_235_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_236_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "unitType": "unit_d6",
          "newHexKey": "-4,1"
        }
      }
    },
    {
      "id": "entry_237_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "rec_red_2_5_1",
          "fromHexKey": "-2,0",
          "toHexKey": "-4,1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_238_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "unitType": "unit_d10",
          "newHexKey": "-1,0"
        }
      }
    },
    {
      "id": "entry_239_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "fromHexKey": "1,-1",
          "toHexKey": "-1,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_240_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_241_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_242_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_243_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "combat",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_247_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_248_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_249_MOVE_UNIT",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "dwarf_watch_1",
          "unitType": "unit_d8",
          "newHexKey": "6,0"
        }
      }
    },
    {
      "id": "entry_250_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "dwarf_watch_1",
          "fromHexKey": "4,0",
          "toHexKey": "6,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_251_MOVE_UNIT",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "dwarf_watch_2",
          "unitType": "unit_d8",
          "newHexKey": "5,0"
        }
      }
    },
    {
      "id": "entry_252_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "dwarf_watch_2",
          "fromHexKey": "3,1",
          "toHexKey": "5,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_253_MOVE_UNIT",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "dwarf_watch_3",
          "unitType": "unit_d8",
          "newHexKey": "1,0"
        }
      }
    },
    {
      "id": "entry_254_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "dwarf_watch_3",
          "fromHexKey": "2,2",
          "toHexKey": "1,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_255_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_256_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_257_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 7,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_258_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 7,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_259_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_260_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,0",
          "unitId": "dwarf_watch_3",
          "unitHexKey": "1,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_261_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,1",
          "unitId": "dwarf_watch_1",
          "unitHexKey": "6,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_262_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-2",
          "unitId": "dwarf_watch_2",
          "unitHexKey": "5,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_263_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-1",
          "unitId": "dwarf_watch_3",
          "unitHexKey": "1,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_264_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_265_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 8,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_266_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_267_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_268_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 8,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_269_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_270_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_271_MOVE_UNIT",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "unitType": "unit_d10",
          "newHexKey": "-3,1"
        }
      }
    },
    {
      "id": "entry_272_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_red_4_7_-1",
          "fromHexKey": "-1,0",
          "toHexKey": "-3,1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_273_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_274_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_275_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_276_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_277_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_278_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_279_MOVE_UNIT",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "dwarf_watch_1",
          "unitType": "unit_d8",
          "newHexKey": "8,0"
        }
      }
    },
    {
      "id": "entry_280_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "dwarf_watch_1",
          "fromHexKey": "6,0",
          "toHexKey": "8,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_281_MOVE_UNIT",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "dwarf_watch_2",
          "unitType": "unit_d8",
          "newHexKey": "7,0"
        }
      }
    },
    {
      "id": "entry_282_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "dwarf_watch_2",
          "fromHexKey": "5,0",
          "toHexKey": "7,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_283_MOVE_UNIT",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "dwarf_watch_3",
          "unitType": "unit_d8",
          "newHexKey": "0,0"
        }
      }
    },
    {
      "id": "entry_284_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "dwarf_watch_3",
          "fromHexKey": "1,0",
          "toHexKey": "0,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_285_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_286_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "combat",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_287_CALCULATE_MELEE_COMBAT_DAMAGE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "combat",
        "playerColor": "yellow"
      },
      "action": {
        "type": "CALCULATE_MELEE_COMBAT_DAMAGE",
        "payload": {
          "meleeCombatInput": {
            "combatUnits": [
              {
                "id": "dwarf_watch_1",
                "hexKey": "8,0",
                "ownerId": "player_id_yellow",
                "type": "unit_d8",
                "factionId": null,
                "size": 7,
                "maxSize": 8,
                "hasShotThisWarPhase": false,
                "hasFoughtThisWarPhase": false,
                "hasUsedAbilityThisWarPhase": false,
                "capturedFromOwnerId": null,
                "additionalSupply": false,
                "diceRoll1": -3,
                "diceRoll2": 0
              },
              {
                "id": "rec_red_4_9_-1",
                "hexKey": "9,-1",
                "ownerId": "player_id_red",
                "type": "unit_d4",
                "factionId": "orcs",
                "size": 2,
                "maxSize": 4,
                "hasShotThisWarPhase": false,
                "hasFoughtThisWarPhase": false,
                "hasUsedAbilityThisWarPhase": false,
                "capturedFromOwnerId": null,
                "additionalSupply": false,
                "diceRoll1": -2,
                "diceRoll2": 0
              }
            ],
            "unitToEnemiesMapping": {
              "rec_red_4_9_-1": [
                {
                  "id": "dwarf_watch_1",
                  "hexKey": "8,0",
                  "ownerId": "player_id_yellow",
                  "type": "unit_d8",
                  "factionId": null,
                  "size": 7,
                  "maxSize": 8,
                  "hasShotThisWarPhase": false,
                  "hasFoughtThisWarPhase": false,
                  "hasUsedAbilityThisWarPhase": false,
                  "capturedFromOwnerId": null,
                  "additionalSupply": false
                }
              ],
              "dwarf_watch_1": [
                {
                  "id": "rec_red_4_9_-1",
                  "hexKey": "9,-1",
                  "ownerId": "player_id_red",
                  "type": "unit_d4",
                  "factionId": "orcs",
                  "size": 2,
                  "maxSize": 4,
                  "hasShotThisWarPhase": false,
                  "hasFoughtThisWarPhase": false,
                  "hasUsedAbilityThisWarPhase": false,
                  "capturedFromOwnerId": null,
                  "additionalSupply": false
                }
              ]
            }
          }
        }
      }
    },
    {
      "id": "entry_288_APPLY_MELEE_DAMAGE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "combat",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_MELEE_DAMAGE",
        "payload": {
          "round": 8,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "combat"
        }
      }
    },
    {
      "id": "entry_289_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "combat",
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "combat"
        }
      }
    },
    {
      "id": "entry_290_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "combat",
        "playerColor": "yellow"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 8,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_291_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "combat",
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 8,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "combat"
        }
      }
    },
    {
      "id": "entry_292_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_293_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,0",
          "unitId": "dwarf_watch_3",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_294_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,1",
          "unitId": "dwarf_watch_1",
          "unitHexKey": "8,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_295_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-2",
          "unitId": "dwarf_watch_2",
          "unitHexKey": "7,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_296_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-1",
          "unitId": "dwarf_watch_3",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_297_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,0",
          "unitId": "dwarf_watch_2",
          "unitHexKey": "7,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_298_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_299_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 9,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_300_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_301_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_302_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 9,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_303_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_304_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_305_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_306_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_307_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_308_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_309_MOVE_UNIT",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "dwarf_watch_1",
          "unitType": "unit_d8",
          "newHexKey": "7,1"
        }
      }
    },
    {
      "id": "entry_310_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "dwarf_watch_1",
          "fromHexKey": "8,0",
          "toHexKey": "7,1",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_311_MOVE_UNIT",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "dwarf_watch_2",
          "unitType": "unit_d8",
          "newHexKey": "5,0"
        }
      }
    },
    {
      "id": "entry_312_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "dwarf_watch_2",
          "fromHexKey": "7,0",
          "toHexKey": "5,0",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "e_313_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "Легат. Живой я. Меня из-под вала — вот этот выдернул. За шиворот. Как щенка из бочки. Я ему говорю — я тебя не звал. А он мне: «Не сегодня, человек. Сегодня очередь не твоя». И УШЁЛ.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_atilius_saved.png"
      }
    },
    {
      "id": "e_314_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "Тяжёлый ты, человек. Ешь меньше.",
        "characterName": "Датри",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m3_datri.png"
      }
    },
    {
      "id": "e_315_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "Тан… Регин, так? Рим благодарит вас. Но Рим должен понять. Кто вы? Откуда вы пришли? Как давно вы… там, внизу?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_lucius_doubt.png"
      }
    },
    {
      "id": "e_316_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "Слышал, Датри? «Как давно»! Он спрашивает — как ДАВНО!",
        "characterName": "Регин",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m3_regin_laugh.png"
      }
    },
    {
      "id": "e_317_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "Я не вижу, что смешного, тан.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_lucius_doubt.png"
      }
    },
    {
      "id": "e_318_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "В том и смех, человек. В том и смех, что не видишь. Вы триста лет копали НАШЕ золото в Бессе и звали его своим. Вы клали дороги по нашим меткам и хвалили своих землемеров — прямые, мол. Вы великая раса, спору нет: так громко жить над чужим домом — это талант. Знать о вас — не труд, человек. Труд — это было о вас НЕ знать.",
        "characterName": "Регин",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m3_regin_laugh.png"
      }
    },
    {
      "id": "e_319_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "Тогда почему вы вышли? Почему сейчас? Кто вас послал?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_lucius_doubt.png"
      }
    },
    {
      "id": "e_320_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "Счёт.",
        "characterName": "Регин",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m3_regin_stern.png"
      }
    },
    {
      "id": "e_321_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "Какой счёт?",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_lucius_doubt.png"
      }
    },
    {
      "id": "e_322_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "Старый. Вино кислое. У вас всё молодое… Не люблю быть должен.",
        "characterName": "Регин",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m3_regin_stern.png"
      }
    },
    {
      "id": "e_323_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "Тан. Один вопрос. ОДИН. Эти орки — что это? Откуда они? Что гонит их на запад? Ты знаешь — я вижу, что знаешь!",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_lucius_doubt.png"
      }
    },
    {
      "id": "e_324_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "Знаю. А ты — узнаешь. В этом, человек, вся разница между нами: мы знаем, а вам — предстоит. Иногда я вам даже завидую. Не благодари. Мы платим не тебе.",
        "characterName": "Регин",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m3_regin_stern.png"
      }
    },
    {
      "id": "e_325_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "…Мальчик. Я сорок лет думал, что видел всё. Хорошая новость: я ошибался, и мир больше, чем я думал. Плохая: он больше НАСТОЛЬКО, что нашего «всё» в нём — на донышке фляги.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_barba_grim.png"
      }
    },
    {
      "id": "e_326_replica",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "kind": "replica",
      "replica": {
        "text": "«Если кто-то помог тебе бескорыстно — ты ещё не видел счёта»… Отец. Кажется, впервые в жизни ты меня не успокоил.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m3_lucius_doubt.png"
      }
    },
    {
      "id": "entry_327_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_328_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_329_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 9,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_330_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fortificationism",
            "name": "Фортификационизм",
            "description": "Мгновенное строительство и скидка для крепостей\nБонус к урону рядом с крепостью",
            "implemented": true,
            "color": "#865333"
          },
          "round": 9,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_331_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_332_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "7,1",
          "unitId": "dwarf_watch_1",
          "unitHexKey": "7,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_333_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "5,0",
          "unitId": "dwarf_watch_2",
          "unitHexKey": "5,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_334_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,0",
          "unitId": "dwarf_watch_3",
          "unitHexKey": "0,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_335_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "8,-2",
          "unitId": "dwarf_watch_2",
          "unitHexKey": "5,0",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_336_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,-1",
          "unitId": "dwarf_watch_1",
          "unitHexKey": "7,1",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_337_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_338_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true,
            "color": "#98172d"
          },
          "round": 10,
          "currentPlayerId": "player_id_yellow",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_339_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_340_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_341_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 10,
          "currentPlayerId": "player_id_yellow",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_342_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_343_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "red"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_344_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_345_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "red",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "red"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_red",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_346_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_347_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "yellow"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_348_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS",
        "payload": {}
      }
    },
    {
      "id": "entry_349_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_350_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 10,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_351_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "yellow",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "yellow"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true,
            "color": "#A9A9A9"
          },
          "round": 10,
          "currentPlayerId": "player_id_yellow",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    }
  ],
  "objectives": [
    {
      "id": "h3_hold_line",
      "type": "survive_rounds",
      "params": {
        "rounds": 6
      },
      "text": "Выстои до перелома",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h3_keep_vercellae",
      "type": "keep_city",
      "params": {
        "centralHexKey": "-5,0"
      },
      "text": "Удержи Верцеллы",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h3_army_size",
      "type": "units_total_size",
      "params": {
        "amount": 24
      },
      "text": "Собери войско отчаяния",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h3_destroy_horde",
      "type": "destroy_all_enemy_units",
      "params": {
        "color": "red"
      },
      "text": "Истреби орду",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h3_tan_word",
      "type": "survive_rounds",
      "params": {
        "rounds": 10
      },
      "text": "Дождись слова тана",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h3_lose_vercellae",
      "type": "lose_city",
      "params": {
        "centralHexKey": "-5,0"
      },
      "text": "Не потеряй Верцеллы",
      "isMain": false,
      "isFailure": true
    }
  ]
};

export default mission;
